<template>
  <component
    v-bind="$attrs"
    v-on="$listeners"
    :is="component"
    v-fusioninputcheck="fusioninputcheck"
    v-model="proxyValue"
  >
    <slot />
  </component>
</template>
<script>
import { computed } from 'vue-demi'

export const SOURCE = '_value'
export const EVENT = '_change'

const FusionCheck = {
  model: {
    prop: SOURCE,
    event: EVENT,
  },
  props: {
    component: {
      require: true,
    },
    fusioninputcheck: {
      type: Object,
      require: true,
    },
    [SOURCE]: {},
  },
  setup (props, { emit }) {
    const proxyValue = computed({
      get () { return props[SOURCE] },
      set (value) { emit(EVENT, value) },
    })
    return {
      proxyValue,
    }
  },
}

export default FusionCheck
</script>
